module.exports = __webpack_public_path__ + "static/img/shine.27badc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/shine.png
// module id = ln+Z
// module chunks = 4